import { ImageCardProps } from '@backrs_ui/common-ui';

import { useToolCardById } from './stickerCardMapping';
import { HomePageSection } from './useGetHomePageSections';

export const EXPLORE_OPPORTUNITIES_SECTION = ({ navigate }: HomePageSection): ImageCardProps[] => {
  const { getImageCard } = useToolCardById({ navigate });

  return [
    getImageCard('explore_universities'),
    getImageCard('discover_jobs'),
    getImageCard('find_scholarships'),
  ];
};
